import { render } from "./ImageTeaser.vue?vue&type=template&id=08a1ef2a&scoped=true&ts=true"
import script from "./ImageTeaser.vue?vue&type=script&lang=ts"
export * from "./ImageTeaser.vue?vue&type=script&lang=ts"

import "./ImageTeaser.vue?vue&type=style&index=0&id=08a1ef2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a1ef2a"]])

export default __exports__